const useSeasonsFlow = () => {
  const isSeasonsFlow = window.location.pathname.includes('/seasonpass');
  return { isSeasonsFlow };
};

export default useSeasonsFlow;
